module.exports = __webpack_public_path__ + "a06e4f33a21385e2e75011c868f72abd.png";